<template>
  <!-- <div class="dropdown-options flex flex-col pl-12 pr-3 pb-8 pt-7"> -->
  <div v-if="!notifications || notifications.length == 0">
    <h4>{{ $t("general.header.noNotifications") }}</h4>
  </div>
  <a
    v-for="notification in notifications"
    :key="notification.id"
    class=" notification-item w-full flex items-center pl-5"
    :href="getnotificationPermalink(notification)"
    @click="openMoment($event, notification)"
  >
    <img
      :src="getImageUrl(notification)"
      class="lazyload notification-img"
      alt="userProfile"
      @error="
        $event.target.src = require('@/assets/images/placeholder-user.svg')
      "
      @click="changeSection('user')"
    />
    <div class="w-auto px-4 notification-title">
      {{ notification.text }}
      <span>
        {{ getTimeFromNow(notification.created) }}
      </span>
    </div>
    <div
      v-if="notification.type === 'friend_request'"
      class="ml-auto mr-8 flex"
    >
      <img
        :src="require('@/assets/images/ic-accept-topaz.svg')"
        class="w-8 cursor-pointer"
        @click.prevent="responseFriend(notification, true)"
      />
      <img
        :src="require('@/assets/images/ic-cancel-grey.svg')"
        class="w-8 cursor-pointer"
        @click.prevent="responseFriend(notification, false)"
      />
    </div>
    <div v-else-if="notification.status === 'unread'" class="mx-6">
      <img :src="require('@/assets/images/circle-topaz.svg')" class="w-3" />
    </div>
  </a>
  <div class="show-more-notifications w-full sticky bottom-0 text-center py-4">
    <w-navigation
      :params="{
        name: 'NotificationsPage'
      }"
      :full="false"
    >
      <template #link>
        {{ $t("wegow.showMore") }}
      </template>
    </w-navigation>
  </div>
</template>

<script setup>
import { useUser } from "@/composables/useUser";
import { useNotification } from "@/composables/useNotification";

import WNavigation from "@/components/general/ui/WNavigation";

import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";

const {
  notifications,
  getNotifications,
  updateNotification
} = useNotification();
const { acceptFriendshipRequest } = useUser();
const router = useRouter();

onBeforeMount(async () => {
  if (notifications.value?.length === 0) {
    await getNotifications();
  }
});

const getImageUrl = notification => {
  if (notification.type === "friend_accept") {
    if (notification.from_user?.thumbnails?.s_sq) {
      return notification.from_user.thumbnails.s_sq;
    } else {
      return require("@/assets/images/placeholder-user.svg");
    }
  } else if (
    notification.reference?.reference_type === "moment" ||
    notification.type === "moments-likes" ||
    notification.type === "moments-comments"
  ) {
    if (notification.reference?.medias[0]) {
      return notification.reference.medias[0].image;
    } else if (notification.from_user?.thumbnails?.s_sq) {
      return notification.from_user.thumbnails.s_sq;
    } else {
      return require("@/assets/images/placeholder-moment.svg");
    }
  } else {
    if (notification.reference?.thumbnails?.s_sq) {
      return notification.reference.thumbnails.s_sq;
    } else {
      return require("@/assets/images/placeholder-" +
        (notification.reference?.reference_type || "notification") +
        ".svg");
    }
  }
};

const responseFriend = async (notification, response) => {
  if (response && notification.from_user) {
    await acceptFriendshipRequest(notification.from_user);
  } else {
    await updateNotification({ id: notification.id, status: "archived" });
  }
  await getNotifications();
};

const getTimeFromNow = time => {
  if (time) {
    return moment(time).fromNow();
  }
  return "";
};

const getnotificationPermalink = notification => {
  if (
    notification.reference?.reference_type !== "moment" &&
    notification.from_user?.permalink
  ) {
    return notification.from_user.permalink;
  } else if (notification.reference?.permalink) {
    return notification.reference.permalink;
  }
  return "";
};
const openMoment = ($event, notification) => {
  if (notification.reference?.reference_type === "moment") {
    $event.preventDefault();
    router.push({
      name: "WegowMoment",
      params: { id: notification.reference.id }
    });
  }
};
</script>

<style scoped lang="scss">
.notification-item {
  height: 110px;
  border-bottom: 1px solid $backgroundLightGrey;
  .notification-img {
    border-radius: 100%;
    height: 77px;
    width: 77px;
    max-width: 77px;
    object-fit: cover;
  }
  .notification-title {
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
    display: -webkit-box;
    -webkit-line-clamp: 3; /* number of lines to show */
    -webkit-box-orient: vertical;
    span {
      color: $textSubtitle;
    }
  }
}
.show-more-notifications {
  box-shadow: 0px 0px 20px 10px #1c1d29;
  background-color: $backgroundGrey;
}
</style>
